<template>
  <section>
    <div class="basic2" v-if="obj">
      <div class="basic2-title">
        <span>
          <el-avatar
            :size="66"
            :src="obj.cover_img"
            class="elAvatar"
          ></el-avatar>
        </span>
        <span>{{ obj.school_name }}</span>
      </div>
      <div class="basic2-content">
        <el-scrollbar
          ref="el_scrollbar"
          wrap-style="overflow-x: hidden;"
        >
          <div class="basic2-tag">
            <div>所属区域：{{ obj.area }}</div>
            <div>客服热线：{{ obj.phone }}</div>
          </div>
          <div class="basic2-btn">
            <div>
              {{ obj.philosophy }}
            </div>
            <div>
              <img :src="require(`@/assets/icon/icon-start3.png`)" alt="" />
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "comDtoBasic2",
  components: {},
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleStatus21(v) {
      this.$emit("status21", v);
    },
    handleStatus20(v) {
      this.$emit("status20", v);
    },
    handleRoute(v, x, y) {
      this.$router.push({
        path: v,
        query: {
          id: x,
          path: 0,
          type: y,
        },
      });
    },
    handleEvaluate(v) {
      this.$emit("evaluate", v);
    },
    handleEdit() {
      this.$emit("edit");
    },
  },
};
</script>

<style scoped lang="scss">
.basic2 {
  height: 100%;
  padding: 22px 30px 0 24px;
  position: relative;
  &-content {
    height: 150px;
    overflow-y: auto;
  }
  &-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    > span {
      &:nth-child(1) {
        margin-bottom: 14px;
      }
      &:nth-child(2) {
        margin-bottom: 14px;
        font-size: 18px;
        color: #333;
        font-weight: bolder;
      }
    }
  }
  &-tag {
    overflow: hidden;
    > div {
      margin-bottom: 4px;
      @include fun-design(5);
      
    }
  }
  &-btn {
    position: relative;
    > div {
      &:nth-child(1) {
        width: 340px;
        @include fun-design(5);
        line-height: 29px;
        text-indent: 2em;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }
      &:nth-child(2) {
        position: absolute;
        top: 6px;
        left: 0;
      }
    }
  }
}
</style>